import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, Loader2 } from "lucide-react";
import api from "../lib/api";
import { PAGE_SEO } from "../data/seoContent";
import SEO, { breadcrumbSchema } from "../components/SEO";
import Breadcrumb from "../components/Breadcrumb";

export default function ComplianceHub() {
  const [posts, setPosts] = useState(null);

  useEffect(() => {
    api.get("/blog?section=hub").then((res) => setPosts(res.data)).catch(() => setPosts([]));
  }, []);

  const crumbs = [{ name: "Home", path: "/" }, { name: "Compliance Hub", path: "/compliance-hub" }];

  return (
    <div data-testid="page-compliance-hub">
      <SEO {...PAGE_SEO.hub} schema={breadcrumbSchema(crumbs)} />
      <section className="bg-[#0A0F1C] text-white pt-16 pb-24 lg:pt-24 lg:pb-32">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
          <div className="mb-8"><Breadcrumb items={crumbs} theme="dark" /></div>
          <p className="text-[10px] uppercase tracking-[0.3em] text-white/50 mb-6">Compliance Hub</p>
          <h1 className="font-display text-5xl lg:text-7xl font-bold tracking-tight max-w-4xl leading-[1.05]">
            Knowledge for <span className="gs-gradient-text">duty holders.</span>
          </h1>
          <p className="mt-8 text-lg text-white/70 max-w-2xl leading-relaxed">
            Legislation explained, guides written by practitioners, and updates on the regulatory landscape affecting UK property compliance.
          </p>
        </div>
      </section>

      <section className="bg-white py-20">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
          {posts === null && (
            <div className="flex justify-center py-20"><Loader2 className="w-6 h-6 animate-spin text-slate-400" /></div>
          )}
          {posts && posts.length === 0 && (
            <p className="text-slate-500 text-center py-20">Articles coming soon.</p>
          )}
          {posts && posts.length > 0 && (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-slate-200 border border-slate-200">
              {posts.map((p) => (
                <Link key={p.id} to={`/compliance-hub/${p.slug}`} className="group bg-white flex flex-col hover:bg-[#0A0F1C] hover:text-white transition-colors" data-testid={`blog-card-${p.slug}`}>
                  {p.cover_image && (
                    <div className="aspect-[16/10] overflow-hidden bg-slate-100">
                      <img
                        src={p.cover_image}
                        alt={p.title}
                        loading="lazy"
                        decoding="async"
                        width="800"
                        height="450"
                        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                        onError={(e) => { e.currentTarget.style.display = "none"; e.currentTarget.parentElement.style.display = "none"; }}
                      />
                    </div>
                  )}
                  <div className="p-8 flex-1 flex flex-col">
                    <p className="text-[10px] uppercase tracking-[0.25em] text-slate-500 group-hover:text-white/50 mb-4">{p.category}</p>
                    <h3 className="font-display text-xl font-semibold mb-3">{p.title}</h3>
                    <p className="text-sm text-slate-600 group-hover:text-white/70 leading-relaxed flex-1">{p.excerpt}</p>
                    <div className="mt-6 flex items-center gap-2 text-sm font-semibold">
                      Read article <ArrowUpRight className="w-4 h-4" />
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
